export default "__VITE_ASSET__BDT3LG$q__"